import Model from 'flarum/common/Model';
export default function transformDate(value) {
  return typeof value === 'string' ? Model.transformDate(value) : null;
}
flarum.reg.add('huseyinfiliz-pickem', 'common/utils/transformDate', transformDate);